
export interface FacultyJSON {
  id: string
  name: string
  description?: string | null
  is_active?: boolean | null
  created_at?: string | null
  updated_at?: string | null
}

export class Faculty {
  readonly id: string
  readonly name: string
  readonly description?: string
  readonly is_active: boolean
  readonly createdAt?: string
  readonly updatedAt?: string

  constructor(options: {
    id: string
    name: string
    description?: string
    is_active?: boolean
    createdAt?: string
    updatedAt?: string
  }) {
    this.id = options.id
    this.name = options.name
    this.description = options.description
    this.is_active = options.is_active ?? true
    this.createdAt = options.createdAt ?? undefined
    this.updatedAt = options.updatedAt ?? undefined
  }

  static fromJSON(json: FacultyJSON): Faculty {
    return new Faculty({
      id: json.id,
      name: json.name,
      description: json.description ?? undefined,
      is_active: json.is_active ?? true,
      createdAt: json.created_at ?? undefined,
      updatedAt: json.updated_at ?? undefined,
    })
  }
}
